import { observable, action, runInAction } from 'mobx';
import { message } from "antd";
import moment from 'moment';
import axios from '@/method/axios';

Number.prototype.toFixed = function (exponent) {
    if (this > 0) {
        return parseInt(this * Math.pow(10, exponent) + 0.5) / Math.pow(10, exponent);
    } else {
        return parseInt(this * Math.pow(10, exponent) - 0.5) / Math.pow(10, exponent);
    }
}

class store {
    @observable data = [];
    @observable data_copy = [];
    @observable checkVal = [];
    @observable area = 'all';
    @observable all_num = 0;
    @observable list_count = [];
    @observable bad_num = 0;
    @observable is_return_num = 0;
    @observable loading = false;
    @observable comments_loading = false;
    @observable page = 1;
    @observable date = moment().subtract(1, 'month').format('YYYY-MM');
    @observable initial_check = true;
    @observable total = 0;
    @observable rivalData = [];
    @observable rival = "";

    @action
    getData = async (score = '5.0', content = '', platform = '', page = 1, replys = '1', name = "") => {
        runInAction(() => {
            this.comments_loading = true;
        })
        try {
            const user = JSON.parse(sessionStorage.getItem('user')) || {};
            let j = await axios.get(`/ota/comment?score=${score}&replys=${replys}&name=${name}&content=${content}&platform=${platform != "all" && platform || ""}&sys_id=${user['comid']}&page=${page}`)
            let Data = j.data || {};
            let count = Data.total || 0;
            let data = Data.rows || [];

            if (this.area === 'all') {
                if (this.initial_check) {
                    runInAction(() => {
                        this.data_copy = data;
                    })
                }
            }

            runInAction(() => {
                this.total = count;
                this.data = data;
                this.comments_loading = false
            })
        } catch (error) {
            runInAction(() => {
                this.comments_loading = false
            })
            console.error(error);
            message.error('数据获取错误!');
        }
    }

    @action
    getDataCount = async (name = "") => {
        const user = JSON.parse(sessionStorage.getItem('user')) || {};
        const res = await axios.get(`/ota/groupPlatform?sys_id=${user['comid']}&score=5.0&name=${name}`);
        let num = (res.data || []).reduce((a, b) => {
            a.num += b.num;
            a.bad += b.bad;
            a.unanswered += b.unanswered;
            return a
        }, { num: 0, bad: 0, unanswered: 0, name: "all" });
        runInAction(() => {
            this.list_count = [num, ...res.data];
            this.all_num = num.all;
        });
    }
    @action
    getRival = async () => {
        const user = JSON.parse(sessionStorage.getItem('user')) || {};
        const res = await axios.get(`/ota/rivalComments?id=${user['comid']}`)
        runInAction(() => {
            this.rivalData = res.data || [];
        })
    }

    radioChange = (e) => {
        this.initial_check = false;
        this.page = 1;
        let platform = e.target.value
        this.getData(
            '5.0',
            '',
            platform,
            1,
            1,
            this.rival
        )
        this.checkVal = [];
        this.area = platform;
    }

    checkChange = (e) => {
        this.initial_check = false;
        this.checkVal = e;
        this.page = 1;
        let score = e.includes('bad') ? '2.0' : '5.0';
        let replys = e.includes('no_response') ? '2' : '1';
        let platform = this.area === 'all' ? '' : this.area;
        this.getData(
            score,
            '',
            platform,
            1,
            replys,
            this.rival
        )
    }

    onChangePage = (page, pageSize) => {
        this.page = page;
        let score = (this.checkVal || []).includes('bad') ? '3.0' : '5.0';
        let replys = (this.checkVal || []).includes('no_response') ? '2' : '1';
        let platform = this.area === 'all' ? '' : this.area;
        this.getData(
            score,
            '',
            platform,
            page,
            replys
        )
        window.scrollTo({ top: 650, behavior: 'smooth' })
    }
}

const groupChannels = new store();
export default groupChannels


// WEBPACK FOOTER //
// ./src/store/groupChannels.js